import { render, staticRenderFns } from "./ReasonAdd.vue?vue&type=template&id=8bd31b28&scoped=true"
import script from "./ReasonAdd.vue?vue&type=script&lang=js"
export * from "./ReasonAdd.vue?vue&type=script&lang=js"
import style0 from "./ReasonAdd.vue?vue&type=style&index=0&id=8bd31b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd31b28",
  null
  
)

export default component.exports